import React from "react";
import { Box, Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";

import { IEReservationIntervalElement } from "modules/appointment/types/IEReservationIntervalElement";

import { DateObjectType } from "utils/DateObject";

interface IProps<T> {
  appointment: T;
  intervalElement: IEReservationIntervalElement | null;
}

const DateTimeTable = <T extends { startDate: DateObjectType }>({
  intervalElement,
  appointment,
}: IProps<T>) => {
  return (
    <Box mt={4} border="solid 1px gray" borderRadius={15} py={4}>
      <Table size="sm">
        <Thead>
          <Tr>
            <Th />
            <Th>Aktualny termin</Th>
            <Th>Nowy termin</Th>
          </Tr>
        </Thead>
        <Tbody>
          <Tr>
            <Td>Data</Td>
            <Td>{appointment.startDate.userFormat()}</Td>
            <Td>{intervalElement?.startDateTime.userFormat()}</Td>
          </Tr>
          <Tr>
            <Td>Godzina</Td>
            <Td>{appointment.startDate.getTime()}</Td>
            <Td>{intervalElement?.startDateTime.getTime()}</Td>
          </Tr>
        </Tbody>
      </Table>
    </Box>
  );
};

export { DateTimeTable };
